// extracted by mini-css-extract-plugin
module.exports = {"navcolor":"Header_navcolor__20B5H","buttonOne":"Header_buttonOne__1pdvI","buttonTwo":"Header_buttonTwo__1feSI"};